import React from "react";
import {
  TableRow,
  TableCell,
  Box,
  Avatar,
  Typography,
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import useStyle from "./Styles";

interface Props {
  curr: any;
  loading: boolean;
  disabled: boolean;
  disconnectedHandler: (data: any) => void;
  connectedHandler: (data: any) => void;
  showUpgradePopUp: () => void;
  closeHandler: (data: any) => void;
  id?: string;
}

const Row: React.FC<Props> = ({
  curr,
  loading,
  disabled,
  disconnectedHandler,
  connectedHandler,
  showUpgradePopUp,
  closeHandler,
  id,
}) => {
  const { classes } = useStyle();

  return (
    <TableRow className={classes.row}>
      <TableCell className={classes.rowCell}>
        <Box className={classes.rowContent}>
          <Box className={classes.pageInfo}>
            <Avatar
              alt={curr.name}
              src={curr.picture}
              className={classes.pageAvatar}
            />
            <Box>
              <Typography className={classes.pageName}>{curr.name}</Typography>
              <Typography className={classes.sourceTag}>
                {curr.source}
              </Typography>
            </Box>
          </Box>

          <Box className={classes.actions} id={id}>
            {curr.isSelected ? (
              <Button
                variant="outlined"
                className={`${classes.actionBtn} ${classes.btnDisconnect}`}
                onClick={() => disconnectedHandler(curr)}
                disabled={disabled}
                endIcon={loading && <CircularProgress size={16} />}
              >
                Disconnect
              </Button>
            ) : (
              <Button
                variant="outlined"
                className={`${classes.actionBtn} ${classes.btnConnect}`}
                onClick={() => {
                  if (curr.isLimitReached) {
                    showUpgradePopUp();
                  } else {
                    connectedHandler(curr);
                  }
                }}
                disabled={disabled}
                endIcon={loading && <CircularProgress size={16} />}
              >
                Connect
              </Button>
            )}

            <Tooltip title="Remove Connection" arrow>
              <IconButton
                className={classes.removeBtn}
                onClick={() => closeHandler(curr)}
                size="small"
              >
                <DeleteOutlineIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default Row;
